export function getTimeStamp (offset, date = new Date(), accountTimeZoneOffset = null) {
  const offsetToSystemTime = date.getTimezoneOffset()
  let epoch = date.getTime()
  if (offset) {
    epoch -= (offset - offsetToSystemTime) * 60000
  } else {
    epoch += offsetToSystemTime * 60000
  }
  const stamp = new Date(epoch)
  const minutes = ("0" + stamp.getMinutes()).slice(-2)
  const hours = ("0" + stamp.getHours()).slice(-2)
  const month = ("0" + (stamp.getMonth() + 1)).slice(-2)
  const day = ("0" + stamp.getDate()).slice(-2)
  const seconds = ("0" + stamp.getSeconds()).slice(-2)
  return `${stamp.getFullYear()}-${month}-${day}, ${hours}:${minutes}:${seconds} ${getOffsetStamp(offset, accountTimeZoneOffset)}`
}

export function getOffsetStamp(offset, accountTimeZoneOffset = null) {
  if (offset === accountTimeZoneOffset) return ""
  if (!offset) return "UTC"
  else {
    const hours = offset / 60
    const minutes = (offset % 60)
    if (hours > 0) return "UTC-" + hours + (minutes ? `:${Math.abs(minutes)}` : "")
    else return "UTC+" + Math.floor(Math.abs(hours)) + (minutes ? `:${Math.abs(minutes)}` : "")
  }
}
